import React from "react";

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>

<p><strong>Effective date:</strong> 26 April 2026</p>
<p><strong>Last updated:</strong> 26 April 2026</p>

        <p>
          Enyi (“Enyi”, “we”, “us”, or “our”) is an AI CFO and
          finance platform designed to help individuals and businesses organise
          financial records, categorise transactions, upload receipts, and
          receive AI-assisted bookkeeping insights.
        </p>

        <p>
          <strong>Enyi is a product of JirOAK Labs Ltd.</strong>
        </p>

        {/* paste the rest of the policy content here */}
      </div>
    </div>
  );
}
export default PrivacyPolicy;